export function getCode(data,callback) {
    this.countDown(data,callback)
  }
  export function countDown(data,callback) {
    const time = 5
    if (!this.timer) {
      this.count = data.time;
      data.btnShow = false;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= data.time) {
          this.count--;
          localStorage.setItem("codeTime",this.count)
          callback(this.count)
        } else {
          data.btnShow = true;
          data.time = 30
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000)
    }
  }
  
  export default {
    getCode,
    countDown
  }
      


// WEBPACK FOOTER //
// ./src/config/getCode.js